/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free solution dilution calculator. Enter any three of stock concentration, stock volume, final concentration and final volume to solve the fourth. Mix units freely.`)
};

const es_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de dilución de soluciones. Introduce tres de los cuatro valores (concentración inicial, volumen inicial, concentración final y volumen final) para calcular el cuarto. Combina unidades libremente.`)
};

const de_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Verdünnungsrechner für Lösungen. Geben Sie drei von Stammkonzentration, Stammvolumen, Endkonzentration und Endvolumen ein, um die vierte Größe zu berechnen. Einheiten können frei gemischt werden.`)
};

const nl_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis verdunningscalculator voor oplossingen. Vul drie van de vier waarden in — stockconcentratie, stockvolume, eindconcentratie en eindvolume — om de vierde te berekenen. Eenheden vrij te combineren.`)
};

const fr_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur gratuit de dilution de solution. Entrez trois valeurs parmi la concentration mère, le volume mère, la concentration finale et le volume final pour résoudre la quatrième. Mélangez les unités librement.`)
};

const it_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito di diluizione di soluzioni. Inserisci tre qualsiasi tra concentrazione madre, volume madre, concentrazione finale e volume finale per risolvere il quarto. Unità liberamente combinabili.`)
};

const pt_br2_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de diluição de soluções. Informe três dos quatro valores — concentração do estoque, volume do estoque, concentração final e volume final — para resolver o quarto. Misture unidades livremente.`)
};

const pt_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de diluição de soluções. Introduza quaisquer três valores entre concentração-mãe, volume-mãe, concentração final e volume final para calcular o quarto. Misture unidades livremente.`)
};

const ja_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料の溶液希釈計算ツール。ストック濃度、ストック体積、最終濃度、最終体積のうち3つを入力すると、残り1つを計算します。単位は自由に混在できます。`)
};

const zh_soldil_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费溶液稀释计算器。输入母液浓度、母液体积、终浓度和终体积中任意三项，求解第四项。可自由混用单位。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_meta_description", locale)
	if (locale === "en") return en_soldil_meta_description(inputs)
	if (locale === "es") return es_soldil_meta_description(inputs)
	if (locale === "de") return de_soldil_meta_description(inputs)
	if (locale === "nl") return nl_soldil_meta_description(inputs)
	if (locale === "fr") return fr_soldil_meta_description(inputs)
	if (locale === "it") return it_soldil_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_meta_description(inputs)
	if (locale === "pt") return pt_soldil_meta_description(inputs)
	if (locale === "ja") return ja_soldil_meta_description(inputs)
	return zh_soldil_meta_description(inputs)
};